export const dateValueGetter = ({ value }: { value: string }): Date | null => {
  const parsed = value ? new Date(value) : null;
  return parsed;
};
